import React from 'react';
import PropTypes from 'prop-types';

import useBrandImage from './useBrandImage';

function BrandImage(props) {

  const { className, style, show } = props;
  const {
    logo, icon, onError, loading,
  } = useBrandImage();

  if (loading) return null;

  return (
    <img
      src={show === 'icon' ? icon : logo}
      alt={show}
      className={className}
      style={style}
      onError={onError}
    />
  );

}

BrandImage.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  show: PropTypes.oneOf(['logo', 'icon']).isRequired,
};

BrandImage.defaultProps = {
  className: null,
  style: null,
};

export default BrandImage;
